var chunkMapping = {
	"1007": [
		6245
	],
	"2853": [
		1729,
		3677
	],
	"2864": [
		2864
	],
	"3054": [
		3054
	],
	"3118": [
		3118
	],
	"3322": [
		3322
	],
	"3983": [
		3983
	],
	"4354": [
		1973
	],
	"4356": [
		4356
	],
	"9305": [
		9929
	]
};
var idToExternalAndNameMapping = {
	"1729": [
		"default",
		"./store/modules/inventoryView",
		5238
	],
	"1973": [
		"default",
		"./components/TankMovement",
		5238
	],
	"2864": [
		"default",
		"./router/index",
		5238
	],
	"3054": [
		"default",
		"./router/moduleConfig",
		5238
	],
	"3118": [
		"default",
		"./router/index.mobile",
		5549
	],
	"3322": [
		"default",
		"./router/index",
		5549
	],
	"3677": [
		"default",
		"./store/modules/tankview",
		5238
	],
	"3983": [
		"default",
		"./components/TankServers",
		5238
	],
	"4356": [
		"default",
		"./router/index.mobile",
		5238
	],
	"6245": [
		"default",
		"./services/startTankServices",
		5238
	],
	"9929": [
		"default",
		"./helpers/translateUnknownTankProduct",
		5238
	]
};
__webpack_require__.f.remotes = function(chunkId, promises) {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function(id) {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = function(error) {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = function() {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = function(fn, arg1, arg2, d, next, first) {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then(function(result) { return next(result, d); }, onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = function(external, _, first) { return external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError(); };
			var onInitialized = function(_, external, first) { return handleFunction(external.get, data[1], getScope, 0, onFactory, first); };
			var onFactory = function(factory) {
				data.p = 1;
				__webpack_require__.m[id] = function(module) {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}